// @flow
import type { EventSink } from '../event-sink';

export type Specification = $ReadOnly<{||}>;

export const logger: EventSink = {
  handleEvent: (event, user) => {
    // eslint-disable-next-line no-console
    console.log(
      `UserEvent:
${JSON.stringify(event, null, 2)}
For User:
${JSON.stringify(user, null, 2)}
`,
    );
  },
};

export const fromSpecification: (Specification) => typeof logger = (
  _specification,
) => logger;

export default logger;
